import { useState, useEffect } from "react";
import clsx from 'clsx'
import { useIntl } from 'react-intl';
import { PageTitle, useLayout } from "../../../_metronic/layout/core";
import { DefaultTitle } from "../../../_metronic/layout/components/header/page-title/DefaultTitle";
import Swal from 'sweetalert2';
import RelatoriosTabela from './RelatorioTabela';
import { useHistory } from "react-router-dom";
import RelatoriosService from "../../services/RelatoriosService";
import { IEsteira } from "../../interfaces/IRelatorioCliente";
import { Tipo } from "./Relatorio";
import { useAuth } from "../../contexts/AuthProvider";

export function limparDados() {
    localStorage.setItem(`${Tipo.Empresa}`, JSON.stringify(null));
    localStorage.setItem(`${Tipo.DataInicial}`, JSON.stringify(null));
    localStorage.setItem(`${Tipo.DataFinal}`, JSON.stringify(null));
}

export function pegarEsteiraSelecionada(): IEsteira | undefined {
    const json = localStorage.getItem(`${Tipo.Esteira}`) ?? "";
    const esteira = (json ? JSON.parse(json) : {}) as IEsteira;

    return esteira;
}

function RelatorioSelecionarCliente() {
    const intl = useIntl();
    const { classes } = useLayout();
    const { usuario } = useAuth();
    const [esteiras, setEsteiras] = useState<IEsteira[]>([]);
    const [carregado, setCarregado] = useState<boolean>(false);
    const history = useHistory();
    const columns = [
        {
            name: 'Cliente',
            selector: (row: IEsteira) => row['razaoSocial'],
            sortable: true,
        },
        {
            name: 'CNPJ',
            selector: (row: IEsteira) => row['cnpj'],
            sortable: true
        },
        {
            name: 'Situação Cadastral',
            selector: (row: IEsteira) => row['situacaoCadastral'],
            sortable: true
        },
        {
            name: 'Ações',
            cell: (row: IEsteira) => <AcoesEsteira excluirEsteira={excluirEsteira} esteira={row} />
        }
    ];

    useEffect(() => {
        async function preCarregar() {
            if(usuario?.perfil === 'Analista'){
                await RelatoriosService.obterEmpresasPorUsuarioID(usuario.id, x => setEsteiras(x));
            }else{
                if(usuario?.clienteID){
                    await RelatoriosService.obterEmpresasPorClienteID(usuario.clienteID, x => setEsteiras(x));
                }
            }
            
            setCarregado(true);
        }

        limparDados();
        preCarregar()
    }, [])

    function AcoesEsteira({ esteira, excluirEsteira }: { esteira: IEsteira, excluirEsteira: (esteira: IEsteira) => void }) {
        return <div data-tag="allowRowEvents">
            <i onClick={() => excluirEsteira(esteira)} className="fas fa-trash-alt fs-1" style={{ color: '#5E6397', marginLeft: '20px', fontWeight: 'normal', cursor: 'pointer' }} />
        </div>
    }

    async function excluirEsteira(esteira: IEsteira) {
        const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
                confirmButton: 'btn btn-modal-excluir ms-5',
                cancelButton: 'btn btn-modal-cancelar'
            },
            buttonsStyling: false
        });
        const result = await swalWithBootstrapButtons.fire({
            title: 'Excluir Relatório',
            html: `Você realmente deseja excluir os relatórios desse Cliente? <br> Há várias contas analisadas dentro desses relatórios.`,
            showCancelButton: true,
            cancelButtonText: 'Cancelar',
            confirmButtonText: `Excluir`,
            reverseButtons: true
        });

        if (result.isConfirmed && esteira.empresaID) {
            await RelatoriosService.excluirCliente(esteira.empresaID, () => setEsteiras(esteiras.filter(x => x.id !== esteira.id)), 'Relatórios excluído com sucesso');
        }
    }

    return <>
        <PageTitle breadcrumbs={[]}>{intl.formatMessage({ id: 'MENU.RELATORIOS' })}</PageTitle>
        <div className='toolbar' id='kt_toolbar'>
            <div id='kt_toolbar_container' className={clsx(classes.toolbarContainer.join(' '), 'd-flex flex-stack')}>
                <DefaultTitle />
            </div>
        </div>

        {
            carregado ?
                <RelatoriosTabela colunas={columns} itens={esteiras} acaoTocarLinha={e => {
                    history.push(`relatorio/${e.empresaID}`);
                    localStorage.setItem(`${Tipo.Relatorio}`, e?.razaoSocial ?? "");
                    localStorage.setItem(`${Tipo.Esteira}`, JSON.stringify(e));
                }} />
                : <p>Carregando...</p>
        }
    </>
};

export default RelatorioSelecionarCliente;